import script from "./ReserveUnit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReserveUnit.vue?vue&type=script&setup=true&lang=ts"

import "./ReserveUnit.vue?vue&type=style&index=0&id=5f50d5d4&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f50d5d4"]])

export default __exports__